import { render, staticRenderFns } from "./UpgradePlanNotification.vue?vue&type=template&id=5b22e11a&scoped=true&"
import script from "./UpgradePlanNotification.vue?vue&type=script&lang=js&"
export * from "./UpgradePlanNotification.vue?vue&type=script&lang=js&"
import style0 from "./UpgradePlanNotification.vue?vue&type=style&index=0&id=5b22e11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b22e11a",
  null
  
)

export default component.exports